import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/components/AfterResultBot.css";
import "../styles/components/ThankYouCard.css";
import omnicareLogo from "../assets/icons/logo.svg";
import doctorImage from "../assets/images/doctor.png";
import backIcon from "../assets/icons/back.svg";
import starsIcon from "../assets/icons/stars.svg";
import coffeeIcon from "../assets/icons/coffee.svg";
import LanguageSwitcher from "./LanguageSwitcher";

const ThankYouCard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get the source page from URL params
  const searchParams = new URLSearchParams(location.search);
  const from = searchParams.get('from');

  const handleBack = () => {
    if (from === 'after-quiz-2') {
      navigate("/after-quiz/2");
    } else if (from === 'after-quiz-4') {
      navigate("/after-quiz/4");
    } else {
      navigate("/");
    }
  };

  const handleDone = () => {
    navigate("/");
  };
  return (
    <div className="after-result-bot-container">
      {/* Header */}
      <header className="after-result-bot-header">
        <div className="logo-section">
          <div className="logo" onClick={() => navigate("/landing")} style={{ cursor: 'pointer' }}>
            <img src={omnicareLogo} alt="Pebble Health Logo" className="logo-icon" />
            <span className="logo-text">Pebble Health</span>
          </div>
        </div>
        <div className="header-actions">
          <LanguageSwitcher />
          <div className="back-button" onClick={handleBack}>
            <img src={backIcon} alt="Back" className="back-icon" />
          </div>
        </div>
      </header>

      {/* Doctor illustration above divider */}
      <div className="doctor-divider">
        <img src={doctorImage} alt="Dr. Sam" className="doctor-avatar" />
      </div>

      <div className="thankyou-card-content">
        <div className="thankyou-card">
          <div className="icon-row">
            <img src={starsIcon} alt="Stars" className="cute-icon" />
            <img src={coffeeIcon} alt="Coffee" className="cute-icon" />
          </div>
          <h2 className="thankyou-message">
            Thank you for taking this step to care for your health and your
            loved ones. Your choice today can make a difference for years to
            come. 💚
          </h2>
          <div className="action-buttons">
            <button className="care-button" onClick={handleDone}>
              <span className="answer-title">I will spread the words!</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankYouCard;
